import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, BookOpen, Book, Headphones, Hash } from 'lucide-react';
const values = [{
  icon: BookOpen,
  title: 'Merezco la Vida de mis Sueños',
  badge: 'Guía Maestra de Manifestación',
  price: '$47.00 USD',
  isBonus: false
}, {
  icon: Book,
  title: 'Mi Diario de Manifestación',
  badge: '🎁 BONO 1 — Tu GPS de enfoque diario',
  price: '$17.00 USD',
  isBonus: true
}, {
  icon: Headphones,
  title: 'Los Secretos de los Sonidos Mágicos',
  badge: '🎁 BONO 2 — Frecuencias Binaurales de Alta Vibración',
  price: '$37.00 USD',
  isBonus: true
}, {
  icon: Hash,
  title: 'Números Mágicos para una Vida Abundante',
  badge: '🎁 BONO 3 — Códigos Numéricos de Activación',
  price: '$27.00 USD',
  isBonus: true
}];
export function ValueSection() {
  return <section className="py-20 bg-secondary relative overflow-hidden" id="oferta" data-id="element-284" data-mp="3lv32h15hmmwz">
      <div className="absolute -top-[200px] -right-[200px] w-[600px] h-[600px] rounded-full bg-[radial-gradient(ellipse,rgba(124,58,237,0.08)_0%,transparent_70%)] pointer-events-none" data-id="element-285" data-mp="3lxfj9azier8g" />
      
      <div className="max-w-[1100px] mx-auto px-5 relative z-10" data-id="element-286" data-mp="1o2mp73tiqi8a">
        <div className="text-center mb-12" data-id="element-287" data-mp="1aag6pb2w7z5o">
          <span className="inline-block text-xs font-semibold tracking-[0.15em] uppercase text-violet-light mb-4" data-id="element-288" data-mp="1a7bym2mb4j9q">
            La Oferta del Siglo
          </span>
          <h2 className="font-display text-3xl md:text-[42px] font-bold leading-[1.2] text-white" data-id="element-289" data-mp="220uecpkbcf8w">
            Esto es <span className="text-gold" data-id="element-290" data-mp="26ymiqj259ttz">todo lo que recibes</span> HOY:
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-card border border-gold/15 rounded-[32px] p-7 md:p-12 relative overflow-hidden max-w-[780px] mx-auto shadow-2xl" data-id="element-291" data-mp="1szd3bllrj3r2">
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-violet via-gold to-violet" data-id="element-292" data-mp="ml5eihzlzd35" />
          
          <div className="flex flex-col mb-8" data-id="element-293" data-mp="2oakr47p0ldxh">
            {values.map((item, i) => <div key={i} className={`flex justify-between items-center py-5 gap-4 ${i !== values.length - 1 ? 'border-b border-white/5' : ''}`} data-id="element-294" data-mp="2jbq937yvftef" data-mpi={i}>
                <div className="flex items-center gap-4 flex-1" data-id="element-295" data-mp="2ai4vhryg0i6l">
                  <div className="shrink-0 w-12 h-12 bg-gold/10 border border-gold/20 rounded-lg flex items-center justify-center text-gold" data-id="element-296" data-mp="2afikficcfkjm">
                    <item.icon className="w-6 h-6" data-id="element-297" data-mp="20i473rlpvbvj" />
                  </div>
                  <div data-id="element-298" data-mp="1vjj63pyn4o61">
                    <h4 className="font-bold text-white text-[15px] mb-0.5" data-id="element-299" data-mp="1vl409eh1m53d">{item.title}</h4>
                    <span className={`text-[11px] ${item.isBonus ? 'text-violet-light font-semibold' : 'text-gray-400'}`} data-id="element-300" data-mp="1rjisu8na2j0k">
                      {item.badge}
                    </span>
                  </div>
                </div>
                <div className="text-right shrink-0" data-id="element-301" data-mp="3lx9yyy6eekr9">
                  <span className="text-sm text-gray-500 line-through" data-id="element-302" data-mp="17p93qkx4oyvo">{item.price}</span>
                </div>
              </div>)}
          </div>

          <div className="bg-gradient-to-br from-gold/10 to-violet/10 border border-gold/25 rounded-2xl p-6 md:px-8 md:py-6 flex flex-col md:flex-row justify-between items-center mb-8 gap-4 text-center md:text-left" data-id="element-303" data-mp="1clpp57cy0z52">
            <div data-id="element-304" data-mp="opv6nu43r80y">
              <div className="text-lg font-bold text-gray-300" data-id="element-305" data-mp="oqel30ujnea8">Valor Total del Pack:</div>
              <div className="text-[13px] text-gray-400 mt-1" data-id="element-306" data-mp="toohfes08kxf">Todo lo que recibes HOY</div>
            </div>
            <div className="md:text-right" data-id="element-307" data-mp="xq1plvikl07i">
              <div className="text-xl text-gray-500 line-through mb-1" data-id="element-308" data-mp="xp8eyjghpqk3">$128.00 USD</div>
              <div className="font-display text-[42px] md:text-[52px] font-black text-gradient leading-none" data-id="element-309" data-mp="12r7k9yvsixjo">$9.99</div>
              <div className="text-xs text-gray-400 mt-1" data-id="element-310" data-mp="297t275t2dqci">USD · Pago único · Acceso inmediato</div>
            </div>
          </div>

          <a href="https://pay.hotmart.com/I106896154S" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window !== 'undefined' && window.fbq) {
            window.fbq('track', 'InitiateCheckout');
          }
        }} className="flex items-center justify-center gap-2.5 w-full bg-gradient-to-br from-violet to-violet-dark text-white font-body text-lg font-bold px-6 py-5 rounded-xl shadow-[0_8px_32px_rgba(124,58,237,0.4)] hover:shadow-[0_12px_40px_rgba(124,58,237,0.6)] hover:-translate-y-0.5 transition-all text-center" data-id="element-311" data-mp="2cne1o9pguhd5">
            <ChevronRight className="w-6 h-6" data-id="element-312" data-mp="35bs2ex7xvrse" />
            SÍ, QUIERO MI PACK DE ABUNDANCIA — $9.99 USD
          </a>
          
          <p className="flex items-center justify-center gap-1.5 text-center text-[13px] text-gray-500 mt-4" data-id="element-313" data-mp="30fku4xs2m47a">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true" data-id="element-314" data-mp="39dwv9tqkckdz">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-315" data-mp="3szf6bigjkehw" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-316" data-mp="1tdtb4d0natm" />
            </svg>
            Pago 100% seguro · Procesado por Hotmart · Garantía 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}